import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEventData,
} from "@hermes/fragments/analytics";

import { REFACTORED_RESULTS, SEARCH } from "../constants/grid.constant";

export class SearchRefactoredEvent implements AnalyticsEvent<GTMEventData> {
    public name: string = EVENT_UAEVENT;
    public eventData: { label: string; refactoredLabel: string | undefined };

    constructor(label: string, refactoredLabel: string | undefined) {
        this.eventData = { label, refactoredLabel };
    }

    public formatForGTM(): GTMEventData {
        return {
            event: this.name,
            eventcategory: SEARCH,
            eventaction: REFACTORED_RESULTS,
            eventlabel: `${this.eventData.label} : ${this.eventData.refactoredLabel}`,
        };
    }
}
